<div [@loadingAnimation]="getLoadingAnimationValue()" class="overlay">
  <div class="center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
